import { Button, type ButtonProps, useToast } from "@chakra-ui/react"
import { useAtom } from "jotai"
import { useEffect } from "react"
import { userDetailsAtom } from "../../../components/Menu/menu.store"
import { useArchiveFmpProjectMutation } from "../../../type-and-hooks"
import { type ApolloError } from "@apollo/client"

interface ArchiveFMPProps {
  fmpId: number | null | undefined
  onArchiveSuccess: VoidFunction
  actionType: "archive" | "restore"
  fmpName: string | null
  children?: React.ReactNode
  buttonProps?: ButtonProps
}

export const ArchiveOrRestoreFMP = ({ fmpId, onArchiveSuccess, actionType, fmpName, children, buttonProps }: ArchiveFMPProps): JSX.Element => {
  const [userDetails] = useAtom(userDetailsAtom)
  const [archiveFMPMutation, { data: archiveFMPStatus, loading: archiveLoading }] = useArchiveFmpProjectMutation()
  const toast = useToast()

  const handleError = (error: ApolloError | Error): void => {
    toast({
      title: "Error",
      description: error?.message,
      status: "error",
      duration: 5000,
      isClosable: true
    })
  }

  const handleMainClick = (): void => {
    if (fmpId === undefined || fmpId === null) {
      return
    }

    if (userDetails?._id) {
      const userID = userDetails?._id ?? null
      archiveFMPMutation({ variables: { archiveFmpProjectId: fmpId, archiveFmpProjectUserId: userID, archive: actionType === "archive" } }).catch(
        handleError
      )
    } else {
      const missingUserIdError = new Error("Archive Failed. Please try again.")
      handleError(missingUserIdError)
    }
  }
  const showToast = (): void => {
    if (archiveFMPStatus) {
      toast({
        title: actionType === "archive" ? "Archived" : "Restored",
        description: fmpName ? `"${fmpName}" ${actionType === "archive" ? "archived" : "restored"} successfully` : "FMP archived successfully",
        status: "success",
        duration: 5000,
        isClosable: true
      })
      onArchiveSuccess()
    }
  }

  useEffect(showToast, [archiveFMPStatus])

  return (
    <Button
      fontSize="12px"
      isLoading={archiveLoading}
      whiteSpace="normal"
      variant="linkButton"
      fontWeight="400"
      onClick={handleMainClick}
      {...buttonProps}
    >
      {children ?? (actionType === "archive" ? "Archive" : "Restore")}
    </Button>
  )
}
